import { c as _c } from "react/compiler-runtime";
import { ContentContainer } from '@/components/layout';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Trans, useTranslation } from 'react-i18next';
import Image from 'next/image';
import React from 'react';
export function Csob() {
  const $ = _c(18);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["insurance"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("csob.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="w-full shrink"><Image src="/images/sections/insurance/cs/csob.png" alt={t1} width={615} height={656} className="md:max-w-fullg mx-auto max-w-[90%]" /></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-blue-500" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = <SectionHeadline className="mb-4 lg:text-left" anchorKey="csob.title"><Trans t={t} i18nKey="csob.title">{t3}</Trans></SectionHeadline>;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("csob.text");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <p className="text-center lg:text-left">{t5}</p>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <div className="shrink-0 md:w-[29.25rem]">{t4}{t6}</div>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t7) {
    t8 = <div className="relative overflow-hidden bg-blue-50"><div className="relative z-10"><ContentContainer><div className="flex flex-col items-center gap-12 lg:flex-row lg:gap-10">{t2}{t7}</div></ContentContainer></div></div>;
    $[15] = t2;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}